var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainAuthLayout',{scopedSlots:_vm._u([{key:"form",fn:function(){return [_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }